module.exports = __webpack_public_path__ + "images/pld_logo_invoice.gif";